import BeeNFTAbi from './abis/BeeNFTAbi';
import HoneyPotsAbi from './abis/HoneyPotsAbi';
import YieldAbi from './abis/YieldAbi';
import MTokenAbi from './abis/MTokenAbi';
import ReferralMintAbi from './abis/referralABI';

const config = {
  BeeNFTAbi,
  HoneyPotsAbi,
  YieldAbi,
  MTokenAbi,
  ReferralMintAbi,
  BeeNFTAddress: '0x4848a07744E46bb3eA93AD4933075a4Fa47b1162',//mainnet
  HoneyPotsAddress: '0xc826EC6b6Aec86e3E1498EaB9Cb9876F40aD0745',//mainnet
  YieldAddress: '0xc27192f3880b991f1059a38eF12d8b63891C5982',//mainnet
  TokenAddress: '0xabf266e61ea49e8e34c4aeffb37e0dfc40671d61',//mainnet
  ReferralMintAddress: '0x5Cc55C3ccE0D2757e07190D3aF041F4B39Cd377D',//mainnet
  // BeeNFTAddress: '0xcf8142ff19fE4eD50Edd55E100fF3CAEAa573043',//g
  // HoneyPotsAddress: '0x4eF9081718aa24047b5BFA494A857Aa8Fd292308',//g
  // YieldAddress: '0xa9C13C6aE8873031a163DCAAB4Bc759021Ad0961',//g
  // TokenAddress: '0x76dA8c8832b5c69f168108F1780297F46F6F643E',//g
  // ReferralMintAddress: '0x54Da1Ad2b643dD65FE39408A655Ef1Ad4E7245E8',//g

  infuraProvider: 'https://mainnet.infura.io/v3/b111d8f387c847039541e29435e06cd2',
  urlOpenSea: "https://opensea.io/assets/ethereum",
  urlEtherScan: "https://etherscan.io"
};

export default config;
